import { Box, Grid, Link } from "@material-ui/core";
import cloneDeep from "lodash/cloneDeep";
import MaterialTable from "material-table";
import React, { useMemo, useState } from "react";
import { BoxCard, PageLayout } from "ui/componentes";
import { LocalizationPTBr } from "util/MaterialTableUtil";
import { Collections } from "api/model/Collections";
import { useCollection } from "api/hooks/useCollection";
import { TrackForm } from "ui/views/TracksView/TrackForm";
import { Track } from "api/model/Track";

const TracksView = () => {
    const [trackEditing, setTrackEditing] = useState<Track | undefined>();
    const tracks =
        useCollection<Track[]>(
            {
                collection: Collections.TRACKS,
            },
            true
        ) || [];

    const tracksOrdered = useMemo(
        () =>
            tracks.sort((t1, t2) =>
                t1.friendlyName < t2.friendlyName ? -1 : 1
            ),
        [tracks]
    );

    return (
        <PageLayout
            title="Pistas"
            boxCardProps={{ padding: 0 }}
            showInBoxCard={false}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <TrackForm
                        track={trackEditing}
                        onCancel={() => setTrackEditing(undefined)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <MaterialTable
                        components={{ Container: BoxCard }}
                        columns={[
                            {
                                field: "name",
                                title: "Nome",
                            },
                            {
                                field: "friendlyName",
                                title: "Nome comercial",
                            },
                            {
                                field: "description",
                                title: "Descrição",
                                filtering: false,
                            },
                            {
                                field: "courses",
                                title: "Traçado(s)",
                                filtering: false,
                                render: (car) => {
                                    if (
                                        !car.courses ||
                                        car.courses.length === 0
                                    )
                                        return;
                                    return (
                                        <Box display="flex">
                                            {car.courses.map(
                                                (course, index) => (
                                                    <Box key={index}>
                                                        {index > 0 && "|"}
                                                        <Link
                                                            target="_blank"
                                                            href={
                                                                course.image
                                                                    ?.downloadURL
                                                            }
                                                            rel="noreferrer"
                                                            style={{
                                                                marginRight: 5,
                                                                marginLeft: 5,
                                                            }}
                                                        >
                                                            {course.name}
                                                        </Link>
                                                    </Box>
                                                )
                                            )}
                                        </Box>
                                    );
                                },
                            },
                        ]}
                        data={cloneDeep(tracksOrdered)}
                        actions={[
                            {
                                icon: "edit",
                                tooltip: "Editar",
                                onClick: (event, rowData) =>
                                    setTrackEditing(rowData as Track),
                            },
                        ]}
                        options={{
                            pageSize: 10,
                            toolbar: false,
                            filtering: true,
                        }}
                        localization={LocalizationPTBr}
                    />
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export { TracksView };
